/**
 * Created by mac on 9/18/22
 */

const ShortMetaLocation = function (locationConfig, slot) {
    this.slot = slot;

    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;

    this.stage = this.slot.load("stage") || 0;
    this.progress = this.slot.load("progress") || 0;
};

ShortMetaLocation.prototype.save = function () {
    this.slot.save("stage", this.stage);
    this.slot.save("progress", this.progress);
};

ShortMetaLocation.prototype.getStage = function () {
    return this.stage;
};

ShortMetaLocation.prototype.setStage = function (stage) {
    this.stage = stage;
    this.save();

    cleverapps.user.incProgressCompare();
};

ShortMetaLocation.prototype.changeProgress = function (progress) {
    this.setProgress(this.progress + progress);
};

ShortMetaLocation.prototype.setProgress = function (progress) {
    this.progress = progress;
    this.save();

    cleverapps.user.incProgressCompare();
};

ShortMetaLocation.prototype.getProgress = function () {
    return this.progress;
};

ShortMetaLocation.prototype.isCompleted = function () {
    return this.progress >= ShortMetaLocation.LEVELS_PER_LOCATION;
};

ShortMetaLocation.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    if (!cleverapps.isKnockoutGame() || cleverapps.knockoutGame.rumble.outcome === Rumble.OUTCOME_WIN) {
        cleverapps.user.incPhysicalLevel();

        this.multiplyRewards(game, this.getProgress());
        this.changeProgress(1);

        if (this.isCompleted()) {
            this.setProgress(0);
            this.setStage(this.stage + 1);
        }
    }
};

ShortMetaLocation.prototype.getReward = function (level) {
    return RewardsConfig.ShortMeta[level % ShortMetaLocation.LEVELS_PER_LOCATION];
};

ShortMetaLocation.prototype.multiplyRewards = function (game, level) {
    const reward = this.getReward(level);
    if (reward) {
        for (const type in reward) {
            let amount = game.rewards[type] * (reward[type].factor || 1);
            amount -= game.rewards[type];

            if (type === GameBase.REWARD_HARD) {
                game.addHardReward(amount);
            } else if (type === GameBase.REWARD_SOFT) {
                game.addSoftReward(amount);
            }
        }
    }
};

ShortMetaLocation.GetMainScene = function () {
    return bundles.main.jsons.shortmetascene_prefab_json;
};

ShortMetaLocation.LEVELS_PER_LOCATION = 10;
